// extracted by mini-css-extract-plugin
module.exports = {"heading":"ConfirmationStep_heading__2KB55","button":"ConfirmationStep_button__2h7lF"};